<mat-dialog-content [formGroup]="form_group" fxLayout="column">
  <i (click)="close()" class="closex fas fa-times"></i>

  <div class="logo">
    <img [src]="environment.publicFolder + 'assets/images/logo.svg'" alt="Zimmerer-Treffpunkt Logo" />
  </div>

  <div class="headline">Gib hier bitte deine Kontaktdaten ein, damit wir dich kontaktieren können:</div>

  <div class="input-row">
    <mat-form-field>
      <input type="text" placeholder="Unternehmen" formControlName="company" class="form-control" matInput />
    </mat-form-field>

    <mat-error
      *ngIf="(was_submitted || form_group.get('company').touched) && form_group.get('company').hasError('required')"
    >
      * Der Name des Unternehmens ist ein Pflichtfeld
    </mat-error>
  </div>

  <div class="input-row">
    <mat-form-field>
      <input type="text" placeholder="Ort" formControlName="location" class="form-control" matInput />
    </mat-form-field>

    <mat-error
      *ngIf="(was_submitted || form_group.get('location').touched) && form_group.get('location').hasError('required')"
    >
      * Der Standort des Unternehmens ist ein Pflichtfeld
    </mat-error>
  </div>

  <div class="input-row">
    <mat-form-field>
      <input type="text" placeholder="Dein Name" formControlName="name" class="form-control" matInput />
    </mat-form-field>

    <mat-error *ngIf="(was_submitted || form_group.get('name').touched) && form_group.get('name').hasError('required')">
      * Der Name ist ein Pflichtfeld
    </mat-error>
  </div>

  <div class="input-row">
    <mat-form-field>
      <input
        type="text"
        placeholder="Deine Position im Unternehmen"
        formControlName="position"
        class="form-control"
        matInput
      />
    </mat-form-field>

    <mat-error
      *ngIf="(was_submitted || form_group.get('position').touched) && form_group.get('position').hasError('required')"
    >
      * Die Position ist ein Pflichtfeld
    </mat-error>
  </div>

  <div class="input-row">
    <mat-form-field>
      <input type="text" placeholder="Deine E-Mail Adresse" formControlName="email" class="form-control" matInput />
    </mat-form-field>

    <mat-error
      *ngIf="(was_submitted || form_group.get('email').touched) && form_group.get('email').hasError('required')"
    >
      * Die E-Mail Adresse ist ein Pflichtfeld
    </mat-error>
  </div>

  <div class="input-row">
    <mat-form-field>
      <input type="text" placeholder="Deine Telefonnummer" formControlName="phone" class="form-control" matInput />
    </mat-form-field>

    <mat-error
      *ngIf="(was_submitted || form_group.get('phone').touched) && form_group.get('phone').hasError('required')"
    >
      * Die Telefonnummer ist ein Pflichtfeld
    </mat-error>
  </div>

  <div class="input-row">
    <mat-checkbox formControlName="consent">
      Im Rahmen Ihrer Anfrage verarbeitet und nutzen wir Ihre angegebenen Daten. Nähere Informationen finden Sie in der
      Datenschutzerklärung.
    </mat-checkbox>

    <mat-error *ngIf="was_submitted && !form_group.value.consent">
      * Bitte stimmen Sie der Datenverarbeitung zu
    </mat-error>
  </div>

  <button class="orange-button" (click)="submit()">Absenden</button>
</mat-dialog-content>
